import DataLoader from "dataloader"
import { useSuspenseQuery } from "@tanstack/react-query"
import {
  getSimpleDutyRosterPeriodStatusesByIds,
  SimpleDutyRosterPeriodStatus,
} from "@/orval/gen"

const loader = new DataLoader<number, SimpleDutyRosterPeriodStatus | null>(
  async (keys) => {
    const results = await getSimpleDutyRosterPeriodStatusesByIds({
      ids: [...keys],
    })
    return keys.map(
      (key) => results.find((x) => x.dutyRosterPeriodStatusId === key) || null
    )
  },
  { batchScheduleFn: (callback) => setTimeout(callback, 100) }
)

export function useBatchedSimpleDutyRosterPeriodStatuses(workAreaId: number) {
  return useSuspenseQuery({
    queryKey: ["SimpleDutyRosterPeriodStatuses", workAreaId],
    queryFn: () => loader.load(workAreaId),
  })
}
